// Se REACT_APP_API_URL è vuoto o undefined, usa percorso relativo per produzione
export const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');